module.exports = __webpack_public_path__ + "img/Monte_Kope_40.43e0ddf7.jpg";